export const TreatzSpaProduct = {
  WEDDING: {
    name: "웨딩 60분",
    value: "WEDDING",
  },
  PRESTIGE: {
    name: "프레스티지 60분",
    value: "PRESTIGE",
  },
};

// 현재 에러를 구분할 수 있는 명확한 코드가 존재하지 않아
// 코드가 생성되기 전까지 에러 메시지를 그대로 코드로 사용
export const TreatzSpaErrorCode = {
  OUT_OF_STOCK: "[BAD_REQUEST] 예약할 수 있는 재고가 존재하지 않습니다.",
  RESERVATION_PENDING_EXISTS:
    "[BAD_REQUEST] 확정 대기 일정이 있어 추가 방문 예약 신청이 불가합니다.",
};
export const TreatzSpaErrorMessage = {
  OUT_OF_STOCK: "해당 시간 예약이 마감되었습니다.\n다른 날짜 / 시간으로 예약 부탁드립니다.",
  RESERVATION_PENDING_EXISTS: "확정 대기 일정이 있어 추가 방문 예약 신청이 불가합니다.",
};
